// Helper function to safely convert to number
export const safeNumber = (value, defaultValue = 0) => {
  const num = parseFloat(value);
  return isNaN(num) ? defaultValue : num;
};

/**
 * Parse OCC option symbol into human-readable format.
 * e.g. "AAPL  250321C00170000" → "AAPL 170C 3/21/25"
 */
export const formatOptionSymbol = (symbol) => {
  if (!symbol) return symbol;
  const match = symbol.replace(/\s+/g, ' ').trim().match(/^(\w+)\s*(\d{6})([CP])(\d{8})$/);
  if (!match) return symbol;
  const [, ticker, dateStr, type, priceStr] = match;
  const month = parseInt(dateStr.slice(2, 4), 10);
  const day = parseInt(dateStr.slice(4, 6), 10);
  const year = dateStr.slice(0, 2);
  const strike = parseInt(priceStr, 10) / 1000;
  const strikeDisplay = strike % 1 === 0 ? strike.toFixed(0) : strike.toFixed(1);
  return `${ticker} ${strikeDisplay}${type} ${month}/${day}/${year}`;
};

/**
 * Convert a timestamp to local time string.
 * PostgreSQL TIMESTAMP columns strip timezone info, so we append 'Z'
 * to treat them as UTC before converting to local.
 */
export const formatLocalTime = (timestamp) => {
  if (!timestamp) return 'N/A';
  let ts = String(timestamp);
  // If it looks like an ISO string without timezone info, treat as UTC
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(ts) && !/[Z+\-]\d{0,4}:?\d{0,2}$/.test(ts)) {
    ts += 'Z';
  }
  return new Date(ts).toLocaleString();
};

/**
 * Calculate human-readable duration between two timestamps.
 * Returns e.g. "2d 4h", "45m", "< 1m"
 */
export const formatDuration = (startTime, endTime) => {
  if (!startTime) return 'N/A';
  const start = new Date(startTime);
  const end = endTime ? new Date(endTime) : new Date();
  const diffMs = Math.abs(end - start);
  const minutes = Math.floor(diffMs / 60000);
  if (minutes < 1) return '< 1m';
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    const remainMin = minutes % 60;
    return remainMin > 0 ? `${hours}h ${remainMin}m` : `${hours}h`;
  }
  const days = Math.floor(hours / 24);
  const remainHours = hours % 24;
  return remainHours > 0 ? `${days}d ${remainHours}h` : `${days}d`;
};
